import { cn } from '../utils/cn';

const SIZES = {
  sm: 'h-3.5 w-5',
  md: 'h-5 w-7',
  lg: 'h-9 w-12',
  xl: 'h-12 w-16',
  xxl: 'h-20 w-28',
};

/**
 * Renders a bundled flag image (same asset pattern as map SVG pattern fills).
 * crossOrigin supports html-to-image export on the stat card.
 */
export default function EntityFlagImage({ src, alt = '', size = 'sm', className }) {
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      crossOrigin="anonymous"
      draggable={false}
      className={cn(
        'inline-block object-cover rounded-[2px] border border-slate-700/50 shrink-0',
        SIZES[size] ?? SIZES.sm,
        className
      )}
    />
  );
}
